import { getTimezone } from "../app/common/getTimezone";
import type { DayjsConstructor } from "../app/common/setupDayjs";

const POLLEN_SEASON_START = "03-16"; // 16.03.
const POLLEN_SEASON_END = "10-14"; // 14.10.

/**
 * Snow season runs from 15.10. to 15.03., pollen season from 16.03. to 14.10.
 * The switch happens at midnight, according to Berlin time.
 */
export const isSnowSeason = (dayjs: DayjsConstructor): boolean => {
    const today = dayjs(
        dayjs().tz(getTimezone(undefined, "de")).format("YYYY-MM-DD")
    );
    const year = today.year();

    return !today.isBetween(
        dayjs(`${year}-${POLLEN_SEASON_START}`),
        dayjs(`${year}-${POLLEN_SEASON_END}`),
        "day",
        "[]"
    );
};
